import CategoryPage from "./views/CategoryPage";
import ExpensesPage from "./views/ExpensesPage";
import FuturePage from "./views/FuturePage";
import IncomePage from "./views/IncomePage";
import LangPage from "./views/LangPage";
import SettingsPage from "./views/SettingsPage";
import ThemesPage from "./views/ThemesPage";
import WidgetPage from "./views/WidgetPage";

export default [
    {name: "dashboard_nav", path: "", icon: "fa-solid fa-square-poll-vertical", component: WidgetPage},
    {name: "future_nav", path: "future", icon: "fa-solid fa-money-bills", component: FuturePage},
    {name: "income_nav", path: "income", icon: "fa-solid fa-coins", component: IncomePage},
    {name: "expenses_nav", path: "expenses", icon: "fa-solid fa-receipt", component: ExpensesPage},
    {name: "themes_nav", path: "themes", icon: "fa-solid fa-palette", component: ThemesPage},
    {name: "settings_nav", path: "settings", icon: "fa-solid fa-gear", component: SettingsPage},
    {name: "language_nav", path: "language", admin: true, icon: "fa-solid fa-language", component: LangPage},
    {name: "category_nav", path: "category", admin: true, icon: "fa-solid fa-list", component: CategoryPage},
]